import { render, staticRenderFns } from "./TriggerButton.vue?vue&type=template&id=7b905e22&"
import script from "./TriggerButton.vue?vue&type=script&lang=js&"
export * from "./TriggerButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports